import { useState } from 'react';
import SpecSourceBadge from "./SpecSourceBadge";
import { stringToColor } from '../../../components/common/colorUtils';
import { IconButton } from '../../../components/common/IconButton';

export default function StackedBadgeList({ children, small = false, showContext = true, className = '', ... otherProps }) {
  const [isExpanded, setIsExpanded] = useState(false);
  const count = (children || []).length;

  if (count === 0) {
    return null;
  }

  const toggleExpand = () => setIsExpanded(!isExpanded);

  const badgeSize = small ? 20 : 40;

  return (
    <div className={"inline-flex items-center " + className} {...otherProps}>
      {isExpanded || count <= 1 ? (
        <>
          {children}
          {count > 1 && <IconButton onClick={toggleExpand} className="px-2 text-xs text-gray-500 hover:text-gray-700" title="Collapse Sources" icon='expand_less' />}
        </>
      ) : (
        <div className="d-inline-block position-relative" title={`Show all ${count} sources`}>
          <span className="badge badge-dark badge-pill position-absolute" style={{top: '38px', left: '10px'}}>
            {count}
          </span>

          {children[0]}

          <div className="text-center" onClick={toggleExpand} >
            {children.slice(1,6).map((child, index) => (
              <div
                key={child.key}
                className="rounded-bottom border border-top-0 border-light inline-block"
                style={{
                  width: `calc(100% - ${(index+1) * 3}px)`,
                  height: `3px`,
                  backgroundColor: stringToColor(child.key) + '99',
                  // marginLeft: '-3px',
                  zIndex: -index -1
                }}
                title={child.key}
              />
            ))}
            <IconButton onClick={toggleExpand} style={{marginTop: '-12px'}} title="Collapse Sources" icon='expand_more' />
          </div>
        </div>
      )}
    </div>
  );
}